import { IInReportToggleOption, ObligatoryFillIn } from './models'
import { TRANSLATION_KEYS } from './translations'

export const IN_REPORT_OPTIONS: IInReportToggleOption[] = [
  {
    key: ObligatoryFillIn.All,
    label: TRANSLATION_KEYS.filters.obligatoryAll,
    tooltip: TRANSLATION_KEYS.filters.obligatoryAllTooltip,
  },
  {
    key: ObligatoryFillIn.Planned,
    label: TRANSLATION_KEYS.filters.inReport,
    tooltip: TRANSLATION_KEYS.filters.inReportTooltip,
  },
  {
    key: ObligatoryFillIn.Excluded,
    label: TRANSLATION_KEYS.filters.excluded,
    tooltip: TRANSLATION_KEYS.filters.excludedTooltip,
  },
]
